// extracted by mini-css-extract-plugin
export default {"cls1":"rmlH_8zc3hM4ffWObh91","cls2":"flsE_oz68QU93MoyEaSo rmlH_8zc3hM4ffWObh91"};